define.alias("checkout/components/payment/payment-method/index", "settings/components/payment/payment-method/index");